export const Asserts = {
  unreachable: (branch: never, data: unknown): never => {
    console.error(
      `ASSERT: This should not be reachable, likely there is a missing condition or switch case for branch ${branch as string}`,
      data
    )
    throw new Error(`Unreachable branch: ${branch}`)
  },
  /** assert some condition and assign to a value or fail */
  val<T>(condition: T, msg?: string, ...info: unknown[]): NonNullable<T> {
    if (!condition) {
      const e = new Error(msg ?? "Expected value to be non-null")
      console.error(e)
      throw e
    }
    return condition
  }
}
